'use strict';

angular.module('licensure.services')
    .factory('EnterpriseLoginCriteria', ['$http', '$q', '$rootScope', 'Cache', function ($http, $q, $rootScope, Cache) {
        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/enterpriselogincriteria', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
            getEnterpriseDisablePasswordLogin: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Core/EnterpriseDisablePasswordLogin', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },
        }
    }])
;